import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`productManage/findList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`productManage/exportList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  generateQRCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`agentList/generateQRCode`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  generateQRUrl({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`agentList/generateQRUrl`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
